import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const TrusteroUserFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => (
  <GenericFilterDropdown
    filterParam={FilterParam.TRUSTERO_USER}
    filterName={FilterName.TRUSTERO_USER}
    valueKey="trusteroUsers"
    isNested={isNested}
  />
)
